import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import { Button } from '@mui/material';

const StyledButton = styled(Button)(({ disabled }) => `
    && {
        width: auto;
        font-size: 16px;
        border-radius: 60px; 
        background-color: ${disabled ? '#ccc' : 'white'}; 
        color: ${disabled ? '#888' : '#227aeb'}; 
        border: 2px solid ${disabled ? '#888' : '#227aeb'}; 
        box-shadow: none; 
        text-transform: capitalize;
    }

    &&:hover {
        background-color: ${disabled ? '#ccc' : 'rgba(34, 122, 235, 0.08)'}; 
        border-color: ${disabled ? '#888' : '#1967CA'};
        color: ${disabled ? '#888' : '#1967CA'};
    }

    @media (min-width: 780px) {
        && {
            padding: 15px 30px;
            font-size: 16px;
            min-width: 150px;
            max-height: 45px;
        }
    }
`);

const SecondaryButton = ({ onClick, children, disabled, startIcon }) => {
    return (
        <StyledButton variant="outlined" onClick={onClick} disabled={disabled} startIcon={startIcon}>
            {children}
        </StyledButton>
    );
};

SecondaryButton.propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.node,
    disabled: PropTypes.bool,
    startIcon: PropTypes.node,
};

export default SecondaryButton;
